export const ActionType = {
  GET_RECENTLY_VIEWED_DEVELOPERS_STARTED:
    'GET_RECENTLY_VIEWED_DEVELOPERS_STARTED',
  GET_RECENTLY_VIEWED_DEVELOPERS_COMPLETED:
    'GET_RECENTLY_VIEWED_DEVELOPERS_COMPLETED',
  SET_RECENTLY_VIEWED_DEVELOPERS: 'SET_RECENTLY_VIEWED_DEVELOPERS',
  RESET_RECENTLY_VIEWED_DEVELOPERS: 'RESET_RECENTLY_VIEWED_DEVELOPERS',
  SET_TIMEZONES: 'SET_TIMEZONES',
};
